export const SET_WISHLIST_UID = 'SET.WISHLIST.UID';
export const SET_WISHLIST_ENTRIES = 'SET.WISHLIST.ENTRIES';
export const DELETE_WISHLIST_ENTRY = 'DELETE.WISHLIST.ENTRY';
export const NOTIFY_PRODUCT = 'NOTIFY.PRODUCT';
export const SET_WISHLIST_ENTRIES_LOADING = 'SET.WISHLIST.ENTRIES.LOADING';
export const UNSET_WISHLIST_ENTRIES_LOADING = 'UNSET.WISHLIST.ENTRIES.LOADING';
